import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintmodsquad = () => {
  const title = "{BRAND.short} brings on Modsquad as human moderators who are at the forefront of Trust and Safety"

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>News</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on March, 2024</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                To enhance its safety moderation further, {BRAND.domainLabel} has
                partnered with Modsquad to provide human moderation to the
                platform&apos;s content.
              </p>

              <p>
                The company was founded by a Silicon Valley lawyer in 2007 who
                enjoyed moderating message boards and saw the early potential of
                online communities, remote work, and social media. Since then,
                Modsquad has pioneered content moderation, community management
                and customer experience.
              </p>

              <p>
                Modsquad are at the forefront of Trust and Safety and have
                expertise in ensuring compliance with digital laws, fraud
                protection, scrubbing content to protect communities online.
              </p>

              <p>
                Modsquad's human moderators bring nuanced judgment and a
                thoughtful approach to content moderation on {BRAND.domainLabel}.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintmodsquad;
